/* eslint-disable camelcase */
import type { SnakeCasedPropertiesDeep } from 'type-fest';

import { keysToCamelCase, keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import type { Access, BillingCycle, RegistrationCampaign, Features, TrialState } from './model';

export interface SiteAccount {
  access: Access;
  adminIds: number[];
  billingCycle: BillingCycle;
  created: number;
  emailOnFirstRecordingEnabled: boolean;
  features: Features;
  id: number;
  nextBillingDate: number | null;
  pictureUrl: string;
  pricingTableId: string;
  registrationCampaign: RegistrationCampaign | null;
  trialState: TrialState | null;
}

export type SiteAccountDto = SnakeCasedPropertiesDeep<SiteAccount>;

export const mapSiteAccountModelToDto = (account: SiteAccount): SiteAccountDto =>
  keysToSnakeCase(account);

export const mapSiteAccountDtoToModel = (account: SiteAccountDto): SiteAccount =>
  keysToCamelCase(account);

export function mockSiteAccountDto(overrides: Partial<SiteAccountDto> = {}): SiteAccountDto {
  return {
    access: 'admin',
    admin_ids: [1],
    billing_cycle: 'yearly_recurring',
    created: 1618365278,
    email_on_first_recording_enabled: false,
    features: ['poll.poll_response_filters'],
    id: 1,
    next_billing_date: 1649894400,
    picture_url: 'http://local.hotjar.com/user/avatar',
    pricing_table_id: '3',
    registration_campaign: null,
    trial_state: null,
    ...overrides,
  };
}

export function mockSiteAccount(overrides: Partial<SiteAccount> = {}): SiteAccount {
  const siteAccountDto = mockSiteAccountDto(keysToSnakeCase(overrides));

  return mapSiteAccountDtoToModel(siteAccountDto);
}
